<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes squat-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #squat-1 {
    animation-name: squat-1;
  }
  @keyframes squat-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #squat-2 {
    animation-name: squat-2;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223.4 536" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="squat-2">
      <path
        fill="var(--hair)"
        d="m129 533-14-3-35-9a21 21 0 0 1-5-2c-3-1-4-3-3-6l2-8a30 30 0 0 1 4-12 11 11 0 0 0 2-5l1-3c1-1 2 1 3 2a15 15 0 0 1 1 2l-1 1a4 4 0 0 0 0 1c0 5 7 12 12 12h4c3-1 7-1 10-3 4-2 3-7 2-10 2-1 4-2 3 1 0 4 3 7 6 9a119 119 0 0 0 19 10l15 6a25 25 0 0 1 3 2c4 3 4 6 1 9s-8 4-13 5l-1 1h-3a8 8 0 0 0-8 0Z"
      />
      <path fill="var(--pants)" d="M134 533a8 8 0 0 1 8 0Z" />
      <path fill="var(--shirt)" d="M18 322ZM136 236Z" />
      <path
        fill="var(--hair)"
        d="m113 215-8-12a12 12 0 0 1-2-6l-1-12c-1-11 6-20 17-23 10-2 20-2 30-1h13c4 0 5 2 4 6 0 4-3 6-4 9a20 20 0 0 0-8-2c-4 1-6 3-4 8 1 2 1 5-1 7-4 3-4 7-4 12 1 3-1 4-4 3-2 0-1-2-2-3a3 3 0 0 0 0-3 6 6 0 0 0-6-5c-3 0-5 2-6 4a23 23 0 0 0-2 10c0 3 0 6-2 8l-2 1h-7Z"
      />
      <path
        fill="var(--hair)"
        d="m134 443 5 1 1 2 1-1a29 29 0 0 1 10 2c2 1 4 3 4 5s-2 4-4 5c-6 3-13 3-20 3l-4-1a11 11 0 0 1 2-5c1-3 4-5 3-8 2 0 3 0 2-3Z"
      />
      <path
        fill="var(--hair)"
        d="m84 490 3 5c4 8 10 7 18 5 4-1 7-3 6-8l1-2c1 3 2 8-2 10-3 2-7 2-10 3h-4c-5 0-12-7-12-12a4 4 0 0 1 0-1ZM132 446c1 3-2 5-3 8a11 11 0 0 0-2 5h-2c1-1 0-1-1-1h-1a68 68 0 0 1 9-12ZM141 444l-1 1-1-1Z"
      />
      <path fill="var(--hair)" d="m122 460 1-2h1v1Z" />
      <path fill="var(--hair)" d="M124 459v-1c1 0 2 0 1 1Z" />
      <path
        fill="var(--hair)"
        d="m96 460-2 5c-9-1-11-3-8-12 2-5 5-11 11-13 0 2 2 2 3 3a1 1 0 0 0 0 1l-3 9-1 7Z"
      />
      <path
        d="M172 274c0-3-3-4-3-7l-10-15c-3-4-7-8-12-10l-4-3c-2-1-4-3-7-3a19 19 0 0 0-7-6h-2l-7-7-8-1-1 1a15 15 0 0 1-6 4 181 181 0 0 0-33 33l-15 20v1a2 2 0 0 1-1 2 1 1 0 0 1-1 1 2 2 0 0 1 0 1 2 2 0 0 0 0-1 1 1 0 0 0-1 1l-1 1c0 2-2 3-3 4l-8 7a29 29 0 0 1-9 9 15 15 0 0 0-6 7 6 6 0 0 1 0 3 6 6 0 0 0 0-3l-3 1v3l-6 5-2 3-1 1c-2 1-4 3-5 6a8 8 0 0 0 2-1 8 8 0 0 1-2 1 4 4 0 0 0-3 3l9 6a25 25 0 0 0 6 4c2 2 5 2 6 4 11 2 21-2 30-5h1l1-1 4-2a3 3 0 0 1 3 1h1a9 9 0 0 0 2 0 13 13 0 0 1 12-1c3 1 5 0 7-3h1a5 5 0 0 1 0-1 5 5 0 0 0 0 1l13-8a6 6 0 0 1 1-1l13-14c8-5 13-13 17-21 2-2 3-3 5-1 5 3 5 3 10-1l14-8c2-1 3-3 5-3q-1-3 3-3l1-4ZM55 342a13 13 0 0 1-1 0 13 13 0 0 0 1 0Zm0-57Zm-2 57Zm1 0Zm0 0h-1 1Zm-1 0Zm-2 1a2 2 0 0 1-1 0 2 2 0 0 0 1 0h-1Zm-1 0a1 1 0 0 0-1 0 1 1 0 0 1 1 0Zm0 0Zm0 0a2 2 0 0 1 0 1 2 2 0 0 0 0-1Zm0 1Zm0 0h-1Zm-1-1Zm-4 2a1 1 0 0 1 1-1 1 1 0 0 0-1 1Zm5 0a9 9 0 0 0 4-1 9 9 0 0 1-4 1Zm10-3h-4 4l5-3-5 3Zm12-3a6 6 0 0 1 2-1 6 6 0 0 0-2 1Zm36-18 2-1a7 7 0 0 1-2 1Z"
        fill="var(--shirt)"
      />
      <path fill="var(--hair)" d="M134 443c1 2 0 3-2 3l1-2Z" />
      <path
        d="m103 330-13 8h-1c-1 3-4 4-7 3a13 13 0 0 0-12 1 9 9 0 0 1-2 0h-1a3 3 0 0 0-3-1l-4 2-1 1h2v1c-2 1-2 0-3-1-9 3-19 7-30 5a5 5 0 0 1 2 2 5 5 0 0 0-2-2 14 14 0 0 1-6 1 14 14 0 0 0 6-1c-1-2-4-2-6-4a25 25 0 0 1-6-4l-9-6c-4 4-5 8-7 13v15l1 2c1 11 8 16 17 21l48 22c1 1 2 0 3-1a42 42 0 0 0 7-9l8-23v-2l2-4c5-9 9-19 19-24l-3-1c-1 0-2-1-1-2 2-3 3-6 7-8l1-2c-1-2-4-1-6-2Zm-73 25Zm4 1Zm0 0h1Zm27-9v1h-1l1-1Zm6 0Zm0 0a3 3 0 0 0-1-2 2 2 0 0 1 0-1 2 2 0 0 0 0 1 3 3 0 0 1 1 2Z"
        fill="var(--pants)"
      />
      <path fill="var(--pants)" d="M59 344h2l-1 1c-1 1-1 0-2-1h1Z" />
      <path
        fill="var(--flesh)"
        d="M221 231c-2-1-4-4-7-3-2 1-3-1-4-1-2-2-6-3-8-1-3 1-7 2-7 7a22 22 0 0 1-1-3l-2-2c-2 0-2 1-2 2-2 7-2 13 0 19 1 3 3 4 5 5l2 2c4 3 5 6 4 11l-2 11a13 13 0 0 0-3 6l-1 1a3 3 0 0 0-2 2c-1 2-2 2-5 0l-14-12-2-1-1 4q-3 0-3 3c-2 0-3 2-5 3l-14 8 15 14c7 6 14 12 22 15a15 15 0 0 0 6 4 7 7 0 0 0 4 2h11a5 5 0 0 0 5-3 2 2 0 0 0 1-3c2-1 2-3 2-5v-2a1 1 0 0 0 1 0v-12l1-12v-18l2-6v-3c0-3 0-5 2-7v-2l2-14a11 11 0 0 0 0-7l-2-2Zm-4 18v-1 1Zm0 4v-2 2Zm-15 37a2 2 0 0 0 0-1 2 2 0 0 1 0 1Zm0-3a2 2 0 0 1 0-1 2 2 0 0 0 0 1Zm-6-33Zm-14 33v1ZM159 363l-3-2a1 1 0 0 0-2-1 3 3 0 0 1-2 0 3 3 0 0 0 2 0c-3-1-5-3-4-7l2-3c3-6-5-14-12-15l-31-3-1 2c-4 2-5 5-7 8-1 1 0 1 1 2l3 1c-10 5-14 15-19 24l-2 4v2l-7 23c9 0 18-1 27-4 2-1 3 0 2 2a60 60 0 0 0-2 11l-1 3a19 19 0 0 0-1 7h1-1v2l-3 10c-1 4-4 7-2 11 0 2 3 2 3 3a6 6 0 0 0 1-1 6 6 0 0 1-1 1 1 1 0 0 0 0 1l-2 9-2 7-2 5-9 24v1l2 5c4 8 11 7 18 5 4-1 7-3 6-8l1-2a27 27 0 0 1 2-14 87 87 0 0 1 8-17l2-1a68 68 0 0 1 8-12l1-2h-1 1l1-1a16 16 0 0 1 1-3 126 126 0 0 0 11-21 55 55 0 0 1 8-13c3-3 5-6 6-10 3-2 3-6 3-10 2-2 2-5 2-7 1-6-1-12-6-16Zm-48-26Zm-9 99a4 4 0 0 1 0 1 3 3 0 0 1 0 1 3 3 0 0 0 0-1 4 4 0 0 0 0-1Zm2 2a3 3 0 0 0-1 0 3 3 0 0 1 1 0Zm7-101h-1ZM87 490a3 3 0 0 0 0-1 3 3 0 0 1 0 1Zm0 1v1-1ZM112 222h8c2 4 5 5 7 8h2a19 19 0 0 1 7 6c3 0 5 2 7 3l1-4a7 7 0 0 1 6-2h6c4 1 6-1 7-5v-4a10 10 0 0 0 3-10c0-2 1-2 2-3 2-1 3-3 2-5a19 19 0 0 0-3-4c-2-3-4-6-2-10l-1-5-2-11a20 20 0 0 0-8-1c-4 0-6 2-4 7 1 2 1 5-1 7-4 3-4 7-4 12 1 3-1 4-4 3-2 0-1-2-2-3a3 3 0 0 0 0-3 6 6 0 0 0-6-5c-3 0-5 2-6 4a23 23 0 0 0-3 10c0 3 1 6-1 8l-2 1h-7v5Zm11 0a7 7 0 0 0 1 3 7 7 0 0 1-1-3Z"
      />
      <path fill="var(--pants)" d="m60 348 1-1v1h-1Z" />
    </g>
    <g id="squat-1">
      <path
        d="m123 255 7-1c0 4 1 9 3 13a23 23 0 0 1 4 22c-3 7 4 11 4 16 0 2 3 2 3 1 3-4 3 1 4 1-2 9 0 19-2 29l-1 8c-1 9-1 9-11 10-15 1-29 3-44 3-10-1-10-1-10-11 0-20-2-40-9-59-3-9-3-18-2-28 4 5 10 5 16 3l24-5h7c3 2 5 0 7-2Z"
        fill="var(--pants)"
      />
      <path fill="var(--shirt)" d="M139 229Z" />
      <path fill="var(--hair)" d="M91 61Z" />
      <path
        fill="var(--hair)"
        d="M156 512c2-2 3-4 2-7s-3-4-5-4c-4 0-7-1-9-3a149 149 0 0 1-22-13c-3-2-6-3-6-7 0-2 0-5-3-3a2 2 0 0 1-1 0c-2 0-2 2-3 3 1 4 0 7-4 8l-1 7c-3 2-7 3-9 8-3 6-11 4-15-4l-3-5c-1-1-2-1-2-3l2-2a1 1 0 0 1 1 0c-1-1-1-3-3-2a3 3 0 0 0-2 3c0 4-1 9 1 13v9a4 4 0 0 0 1-1 4 4 0 0 1-1 1c1 3-1 6 1 9a2 2 0 0 0 2 3l14 4a2 2 0 0 0 2 1h3l7 2 2 1a23 23 0 0 0 9 4l3 1c5 2 10 1 15 0 7-1 14-2 19-6 5-3 6-8 4-12-3-3-2-4 1-5Zm-81-5a6 6 0 0 0 0-1 6 6 0 0 1 0 1Zm0 1a2 2 0 0 0 1 0 2 2 0 0 1-1 0Z"
      />
      <path fill="var(--shirt)" d="M150 252ZM151 253Z" />
      <path
        fill="var(--pants)"
        d="M123 255c-2 2-4 4-7 2h-7c5-1 10-3 14-2Z"
      />
      <path
        fill="var(--hair)"
        d="M144 4c-2-4-5-3-8-2s-6 0-8-2h-23c-2 3-6 2-9 3-12 2-19 11-18 23s3 23 7 34a3 3 0 0 0 1 5l5-4c6-5 2-11 1-16s-1-8 3-10c5-1 8 1 9 6 2 6 5 6 10 2a12 12 0 0 0 1-2 11 11 0 0 1 0-1 11 11 0 0 0 0 1l2-3c1-5 2-9 7-11 2-1 3-4 2-7-1-6 1-8 7-6a45 45 0 0 1 6 3l2-2a20 20 0 0 0 2-2c1-3 3-6 1-9Z"
      />
      <path
        fill="var(--hair)"
        d="M77 492c-1-1-2-1-2-3l2-2v1a4 4 0 0 0 0 1v2Z"
      />
      <path
        fill="var(--pants)"
        d="M77 491v-2l1 1a8 8 0 0 0-1 0 1 1 0 0 0 0 1Z"
      />
      <path
        fill="var(--pants)"
        d="M77 489a4 4 0 0 1 0-1 1 1 0 0 1 0 1Z"
      />
      <path
        d="M149 236c-5-28-6-56-4-85 0-7-1-15-4-21-1-8-5-14-9-20 0-3-2-6-4-8a30 30 0 0 0-7-10 5 5 0 0 0-2-4c-2 1-2 3-2 5 0 4-2 6-6 4-2-2-5-2-7-2-4-5-10-6-15-9l-7-9c-6 5-7 12-11 18-2 5-4 12-8 16v22a139 139 0 0 1 10 68c-2 8-1 17-4 25-4 11-2 22 0 33 4 5 10 5 16 3 8-2 16-5 24-5 5-1 10-3 14-2l7-1a14 14 0 0 0-5-9c-7-6-12-15-19-21-5-5-8-12-11-19 0-3-3-5-2-8h-2v-14l1-1c-3-2-1-5-2-7-2-7-4-13-4-19-3-2-1-5-1-7a35 35 0 0 1 0-10c9 2 18 1 27 1 2 0 4-1 5 3a5 5 0 0 0 1 0 5 5 0 0 1-1 0v26c0 4 0 7 2 11 3 4 3 9 6 14 1 2 3 5 3 9 3 0 1 4 3 4v-1 1l1 3v4c4 2 4 6 4 10 3 1 2 3 3 5 1 0 2 1 1 2l1 2c3 2 3 6 4 9s1 6 5 6c1-4-1-8-1-12Zm-29-87-1-1 1-1 1 1-1 1Zm8-8a2 2 0 0 0-1-2 2 2 0 0 1 1 2Zm-1 15a74 74 0 0 1 1 11 74 74 0 0 0-1-11Zm5 49a16 16 0 0 0 0-3 16 16 0 0 1 0 3Z"
        fill="var(--shirt)"
      />
      <path d="m120 147 1 1-1 1c-1 1 0-1-1-1Z" fill="var(--shirt)" />
      <path
        fill="var(--flesh)"
        d="m151 253-1-1v-4c-4 0-4-3-5-6s-1-7-4-9l-1-2a2 2 0 0 1-1-1 2 2 0 0 0 1 1c1-1 0-2-1-2-1-2 0-4-3-5v5a3 3 0 0 0-1 1 3 3 0 0 1 1-1v-5c0-4 0-8-4-10v-4l-1-3c-2 0 0-4-3-4 0-4-2-7-3-9-3-5-3-10-6-14-2-4-2-7-2-11v-26c-1-4-3-3-5-3-9 0-18 2-27-1a35 35 0 0 0 0 10c0 2-2 5 1 7 0 6 2 12 4 19 1 2-1 5 3 7l-1 1v14h1c-1 3 2 5 3 8 2 7 5 14 10 19 7 6 12 15 19 21a14 14 0 0 1 5 9c0 4 1 9 4 13a23 23 0 0 1 3 22c-2 7 5 11 4 16 0 2 3 2 3 1 3-4 3 1 4 1 6 0 5-5 7-7 1 1 0 4 2 4 3 0 3-2 3-4l3-10c1-8 1-16-3-23l-9-14ZM82 392a44 44 0 0 0-3 7c-3 7-6 13-6 21l4 38c0 10 2 19 1 29a1 1 0 0 0-1 0v1a1 1 0 0 1 0 1l1 1a8 8 0 0 0-1 0 1 1 0 0 0 0 1v1l3 5c4 8 12 10 15 4 2-5 6-6 9-8l1-7c4-1 5-4 4-8 1-1 1-3 3-3l-1-6v-3c1-12-1-23-1-34l1-4 1-5c1-8 0-18 5-25 9-13 12-28 17-44-15 1-29 3-44 3 1 12 0 24-8 35Zm-2 105v-2 2Zm29-24a6 6 0 0 0-1 2 6 6 0 0 1 1-2 10 10 0 0 1 0-1 10 10 0 0 0 0 1Zm4-72a4 4 0 0 0-1-3 4 4 0 0 1 1 3Zm-2-3a4 4 0 0 0-2-1 4 4 0 0 1 2 1ZM77 489ZM86 65c-2 4-1 8-4 12l7 9c5 3 11 4 15 9 2 0 5 0 7 2 4 2 6 0 6-4 0-2 0-4 2-5-1-8 4-13 12-12 3 0 8 1 9-3 1-6 6-10 5-16a4 4 0 0 1 1-4c3-3 2-5 0-8-1-3-5-5-4-8 2-7-2-13-3-20a45 45 0 0 0-6-3c-6-2-8 0-7 6 1 3 0 6-2 7-5 2-6 6-7 11l-2 3a12 12 0 0 1-1 2c-5 4-8 4-10-2-1-5-4-7-9-6-4 2-4 5-3 10s5 11-1 16l-5 4Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>